<template lang="">
  <div class="">
    <PositionGuid :posGuids="posGuids"></PositionGuid>
    <div class="lists gWidth padding bg-white" v-cloak>
      <div>
        <div class="left_tit flex align-center flex-center  text-weight">
          栏目导航
        </div>
        <div class="news_l padding-bottom leftss">
          <ul class="big_ul">
            <li class="default">
              <div>
                <ul class="">
                  <li
                    class="cursor flex align-center"
                    :class="[!isZhuanti ? 'left_fathersel' : 'left_father']"
                  >
                    <span class="padding-left text-weight">通知公告</span>
                  </li>
                </ul>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="news_r padding-bottom">
        <span class="right_tit">通知公告</span>
        <Lists
          :liebiaos="liebiaos"
          :totlePage="totlePage"
          @liebiao2="liebiao2"
        ></Lists>
      </div>
    </div>
  </div>
</template>
<script>
import Lists from "../../components/Lists/Lists";
import PositionGuid from "../../components/PositionGuid/PositionGuid";
import { gg_list } from "@/api/gxq";
export default {
  name: "GonggaoList",
  components: {
    Lists,
    PositionGuid,
  },
  data() {
    return {
      articleTitle: '保定国家高新技术产业开发区', // 初始标题
      contentSource: '保定国家高新技术产业开发区', // 初始内容来源
      liebiaos: [],
      isZhuanti: true, //判断是专题专栏还是文件下载，默认是专题专栏
      isLoading: false,
      currentPage: 1,
      totlePage: 1,
      posGuids: [
        {
          title: "通知公告",
          link: "",
        },
      ],
    };
  },
  mounted() {
    this.liebiao2();
    this.clearExistingMetaTags('ArticleTitle');
      this.clearExistingMetaTags('ContentSource');
  },
  methods: {

    // 清除具有指定名称的现有 meta 标签
    clearExistingMetaTags(name) {
        const existingTags = document.querySelectorAll(`meta[name="${name}"]`);
        existingTags.forEach(tag => tag.parentNode.removeChild(tag));
    },
    async liebiao2(page) {
      const { data } = await gg_list({
        id: 33,
        page: page ? page - 1 : 0,
      });
      this.liebiaos = data.data;
      this.lanmu = data.lanmu;
      // console.log(this.liebiaos);
      this.totlePage = data.pages;
      
    },
  },
};
</script>
<style src="../../../vab/styles/gaikuang/gaikuang_big.css" scoped></style>
<style src="../../../vab/styles/gaikuang/gaikuang_mid.css" scoped></style>
<style src="../../../vab/styles/gaikuang/gaikuang_small.css" scoped></style>
<style scoped>
.down_tit {
  color: #666666;
}
.down_des {
  color: #999;
}
.font-xs {
  font-size: 12px;
}
.down {
  border-bottom: 1px dashed #ccc;
  padding: 10px;
}
</style>
